import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Urgency() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 32,
    seconds: 15
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const progress = 72;
  return <section className="w-full py-8 sm:py-16 bg-violet-rich/30 border-y border-gold/20" data-id="element-295">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-296">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center" data-id="element-297">
          <p className="text-white text-base sm:text-xl mb-1 sm:mb-2" data-id="element-298">
            Oferta de lanzamiento —{' '}
            <span className="text-gold font-semibold" data-id="element-299">+$10.000 DESPUÉS</span> —
            No vuelve a bajar
          </p>
          <p className="text-violet-100/70 text-xs sm:text-sm mb-4 sm:mb-6" data-id="element-300">
            LANZAMIENTO TERMINA EN
          </p>

          <div className="flex justify-center gap-2 sm:gap-4 mb-6 sm:mb-8" data-id="element-301">
            <div className="bg-violet-deep/60 border border-gold/30 rounded-lg px-4 py-3 sm:px-6 sm:py-4 min-w-[60px] sm:min-w-[80px]" data-id="element-302">
              <p className="text-2xl sm:text-4xl font-display font-bold text-gold" data-id="element-303">
                {String(timeLeft.hours).padStart(2, '0')}
              </p>
              <p className="text-[10px] sm:text-xs text-violet-100/60 mt-1" data-id="element-304">
                Horas
              </p>
            </div>
            <div className="bg-violet-deep/60 border border-gold/30 rounded-lg px-4 py-3 sm:px-6 sm:py-4 min-w-[60px] sm:min-w-[80px]" data-id="element-305">
              <p className="text-2xl sm:text-4xl font-display font-bold text-gold" data-id="element-306">
                {String(timeLeft.minutes).padStart(2, '0')}
              </p>
              <p className="text-[10px] sm:text-xs text-violet-100/60 mt-1" data-id="element-307">
                Min
              </p>
            </div>
            <motion.div key={timeLeft.seconds} initial={{
            scale: 0.95
          }} animate={{
            scale: 1
          }} transition={{
            duration: 0.2
          }} className="bg-violet-deep/60 border border-gold/30 rounded-lg px-4 py-3 sm:px-6 sm:py-4 min-w-[60px] sm:min-w-[80px]" data-id="element-308">
              <p className="text-2xl sm:text-4xl font-display font-bold text-gold" data-id="element-309">
                {String(timeLeft.seconds).padStart(2, '0')}
              </p>
              <p className="text-[10px] sm:text-xs text-violet-100/60 mt-1" data-id="element-310">
                Seg
              </p>
            </motion.div>
          </div>

          <div data-id="element-311">
            <p className="text-xs sm:text-sm text-violet-100/70 mb-2" data-id="element-312">
              Cupos restantes
            </p>
            <div className="w-full bg-violet-deep/60 rounded-full h-3 sm:h-4 border border-gold/20 overflow-hidden" data-id="element-313">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: `${progress}%`
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              delay: 0.3
            }} className="bg-gradient-to-r from-gold to-yellow-600 h-full rounded-full" data-id="element-314" />
            </div>
            <p className="text-gold font-semibold text-xs sm:text-sm mt-2" data-id="element-315">
              {progress}% TOMADOS
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}